import * as React from "react";

const Twitter: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 36 36">
            <g fill="none" fillRule="evenodd">
                <circle cx="18" cy="18" r="17.5" stroke="currentColor" />
                <path
                    fill="currentColor"
                    fillRule="nonzero"
                    d="M23.175 10h2.761l-6.031 6.777L27 26h-5.554l-4.353-5.592L12.117 26H9.352l6.45-7.25L9 10h5.695l3.93 5.112L23.176 10zm-.97 14.377h1.529l-9.872-12.839h-1.643l9.986 12.839z"
                />
            </g>
        </svg>
    );
};

export default React.memo(Twitter);
